import React from 'react';
import { ShieldCheck, Globe, Zap, TrendingUp, Award, Lock } from 'lucide-react';
import { benefits } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import MobileSlider from './MobileSlider';

const iconMap = { ShieldCheck, Globe, Zap, TrendingUp, Award, Lock };

const BenefitCard = ({ benefit, index, noAnimation = false }) => {
  const card = useScrollAnimation({ threshold: 0.15 });
  const Icon = iconMap[benefit.icon];
  const delay = (index % 3) + 1;

  return (
    <div
      ref={noAnimation ? undefined : card.ref}
      data-testid={`benefit-item-${index}`}
      className={`group bg-white border border-[#E5E7EB] p-7 transition-all duration-200 ${noAnimation ? '' : `brutalist-hover scroll-fade-up scroll-delay-${delay}`} ${noAnimation || card.isVisible ? 'scroll-visible' : ''}`}
    >
      <div className="w-10 h-10 bg-[#111827] group-hover:bg-[#FF1010] flex items-center justify-center mb-5 transition-colors duration-200">
        {Icon && <Icon className="w-5 h-5 text-white" />}
      </div>
      <h3 className="text-base font-black tracking-tighter text-[#111827] mb-2 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>{benefit.title}</h3>
      <p className="text-sm text-[#4B5563] leading-relaxed">{benefit.description}</p>
    </div>
  );
};

const BenefitsSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="benefits" data-testid="benefits-section" className="py-24 md:py-32 bg-[#F9FAFB] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div ref={header.ref} className={`max-w-2xl mb-14 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="text-xs font-bold uppercase tracking-widest text-[#FF1010] block mb-3">Benefits</span>
          <h2 className="text-3xl sm:text-4xl font-black tracking-tighter text-[#111827] mb-4 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
            What You Get When<br />You Register Your Trademark
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            It is not just a piece of paper. A registered trademark is a weapon, a shield, and an asset — all in one.
          </p>
        </div>

        {/* Desktop grid */}
        <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {benefits.map((benefit, index) => (
            <BenefitCard key={index} benefit={benefit} index={index} />
          ))}
        </div>

        {/* Mobile slider */}
        <div className="sm:hidden">
          <MobileSlider>
            {benefits.map((benefit, index) => (
              <BenefitCard key={index} benefit={benefit} index={index} noAnimation />
            ))}
          </MobileSlider>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
